import defaultLocales from 'globals/locales/default';
import { formatDate } from 'globals/utils';

export const getMessage = (date: number): string =>
  `${defaultLocales.invoicePayNotificationSuccess.prefix} ${formatDate(
    date,
    true
  )} ${defaultLocales.invoicePayNotificationSuccess.suffix}`;
